export const priceRangeMixin = {
  data: () => ({
    forcePush: false,
  }),

  beforeRouteLeave(to, from, next) {
    if (from.fullPath === '/produtos/faixas-precos') {
      this.forcePush = false
      next()
      return
    }
    if (!this.forcePush) {
      this.$confirm({
        title: 'Tem certeza?',
        message:
          'Sua análise ainda não foi salva e todas as suas alterações recentes serão perdidas ao sair dessa página. Para continuar editando clique em <strong>continuar editando</strong>, para sair sem salvar clique em <strong>descartar alterações</strong>.',
        confirmText: 'Continuar editando',
        cancelText: 'Descartar alterações',
      })
        .then()
        .catch(() => {
          next()
        })
    } else {
      this.forcePush = false
      next()
    }
  },
}
